import { noop } from 'lodash';
import { httpCreators, HttpResponse, Tags } from '@ppvrbh/merchant-frontend-core';
import { call, put, putResolve, takeLatest } from 'redux-saga/effects';
import { generalCreators } from '../../../../redux/general/general-action';
import { MODAL_TYPE } from '../../../../redux/general/general-constant';
import { GENERAL_STATE_KEY } from '../../../../redux/general/general-reducer';
import { generalSagas } from '../../../../redux/general/general-saga';
import { history } from '../../../../router';
import { foodMenuSagas } from '../../FoodMenu/redux/foodmenu-saga';
import { catCreators } from './cat-action';
import { CAT_INLINE_ERROR, CAT_REQUEST_ID_LIST, CAT_TRANSLATION_KEY } from './cat-constant';
import { CAT_STATE_KEY } from './cat-reducer';
import { CatService } from './cat-service';
import { CallFoodCategoryAction, CallFullFoodCategoryAction, CallMenuInCatAction, CAT_ACTION_TYPE, SortMenuSequenceAction } from './cat-type';

function* callFoodCategory(action: CallFoodCategoryAction) {
  yield put(httpCreators.request({
    id: CAT_REQUEST_ID_LIST.GET_CAT,
    sagaHandler: getFoodCategoryHandler,
    serviceParams: action.payload?.options,
    service: CatService.getCat,
    callbackParams: { action }
  }));
  yield call(generalSagas.callTnc);
}

function* callFullFoodCategory(action: CallFullFoodCategoryAction) {
  yield put(httpCreators.request({
    id: CAT_REQUEST_ID_LIST.GET_FULL_CAT,
    sagaHandler: getFullFoodCategoryhandler,
    service: CatService.getCat,
    callbackParams: { action }
  }));
  yield call(generalSagas.callTnc);
}

function* callMenuInCat(action: CallMenuInCatAction) {
  yield put(httpCreators.request({
    id: CAT_REQUEST_ID_LIST.GET_MENU_IN_CAT,
    sagaHandler: getMenuInCatHandler,
    service: CatService.getMenuInCat,
    serviceParams: {
      menuCategoryId: action.payload.foodCategoryId,
      search: action.payload.search,
      page: action.payload.page,
      limit: action.payload.limit,
    },
    callbackParams: { action }
  }));
}

function* getFoodCategoryHandler(resp: HttpResponse, callbackParams: { action: CallFoodCategoryAction }) {
  const { onFailureCallback, isAddCategoryPage, onSuccessCallback } = callbackParams.action.payload;
  if (resp.success) {
    yield put(catCreators.setCatState(CAT_STATE_KEY.LIST, resp.data.menuCategories as []));
    if (!isAddCategoryPage) {
      yield call(foodMenuSagas.callGetMenuTags, onFailureCallback, onSuccessCallback)
    }
    if (resp.data.menuCategoryCount) {
      yield put(catCreators.setCatState(CAT_STATE_KEY.CAT_COUNT, resp.data.menuCategoryCount));
    }
    if (resp.data.meta) {
      yield put(catCreators.setCatState(CAT_STATE_KEY.LIST_META_DATA, resp.data.meta))
    }
  } else {
    yield put(catCreators.setCatState(CAT_STATE_KEY.LIST, undefined));
    if (!isAddCategoryPage) {
      yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
        visible: true,
        onOk: onFailureCallback,
        type: MODAL_TYPE.ERROR
      }));
    }
  }
}

function* getFullFoodCategoryhandler(resp: HttpResponse, callbackParams: any) {
  const { onSuccessCallback } = callbackParams.action.payload;
  if (resp.success) {
    const menuCategories = resp.data.menuCategories as [];
    yield putResolve(catCreators.setCatState(CAT_STATE_KEY.FULL_LIST, menuCategories));
    yield call(onSuccessCallback, menuCategories);
  } else {
    yield put(catCreators.setCatState(CAT_STATE_KEY.FULL_LIST, []));
  }
}

function* postCatHandler(
  resp: HttpResponse,
  callbackParams: {
    onSuccessCallback: () => void,
    setFieldError: (fieldName: string, errorShow: string[]) => void
  }) {
  if (resp.success) {
    yield call(callbackParams.onSuccessCallback);
  } else if (resp.statusCode === 1799 && resp.data?.translationKey) {
    for (const key of resp.data?.translationKey) {
      if (key === CAT_TRANSLATION_KEY.MENU_CATEGORY_NAME_TH_DUP) {
        yield call(callbackParams.setFieldError, 'menuCategoryName', [CAT_INLINE_ERROR.MENU_CATEGORY_NAME_DUP]);
      } else if (key === CAT_TRANSLATION_KEY.MENU_CATEGORY_NAME_EN_DUP) {
        yield call(callbackParams.setFieldError, 'menuCategoryNameEN', [CAT_INLINE_ERROR.MENU_CATEGORY_NAME_DUP]);
      }
    }
  } else if (resp.statusCode === 1899) {
    yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      onOk: () => {
        history.goBack();
      },
      type: MODAL_TYPE.ERROR
    }));
  } else {
    yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      onOk: noop,
      type: MODAL_TYPE.ERROR
    }));
  }
}

function* patchCatHandler(
  resp: HttpResponse,
  callbackParams: {
    onSuccessCallback: () => void,
    setFieldError: (fieldName: string, errorShow: string[]) => void,
    onNotificationError: () => void,
    editFrom: any,
    editTo: any,
  }) {
  if (resp.success) {
    yield call(callbackParams.onSuccessCallback);
    yield put(catCreators.setCatState(CAT_STATE_KEY.ALERT_SUCCESS, {
      isVisible: true,
      translationValues: {
        categoryName: callbackParams.editTo.menuCategoryName,
      },
    }));
  } else if (resp.statusCode === 1799 && resp.data?.translationKey) {
    for (const key of resp.data?.translationKey) {
      if (key === CAT_TRANSLATION_KEY.MENU_CATEGORY_NAME_TH_DUP) {
        yield call(callbackParams.setFieldError, 'menuCategoryName', [CAT_INLINE_ERROR.MENU_CATEGORY_NAME_DUP]);
      } else if (key === CAT_TRANSLATION_KEY.MENU_CATEGORY_NAME_EN_DUP) {
        yield call(callbackParams.setFieldError, 'menuCategoryNameEN', [CAT_INLINE_ERROR.MENU_CATEGORY_NAME_DUP]);
      }
    }
  } else if (resp.statusCode === 1899) {
    yield call(callbackParams.onNotificationError);
    yield put(catCreators.setCatState(CAT_STATE_KEY.ALERT_FAILURE, {
      isVisible: true,
      translationValues: {
        categoryName: callbackParams.editFrom.menuCategoryName,
      },
    }));
  } else {
    yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      onOk: noop,
      type: MODAL_TYPE.ERROR
    }));
  }
}

function* deleteCatHandler(resp: HttpResponse, callbackParams: any) {
  if (resp.success) {
    callbackParams();
  } else {
    yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      onOk: noop,
      type: MODAL_TYPE.ERROR
    }));
  }
}

function* updateCategorySequenceHandler(resp: HttpResponse, callbackParams: any) {
  if (resp.success) {
    callbackParams?.();
  } else {
    yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      onOk: noop,
      type: MODAL_TYPE.ERROR
    }));
  }
}

function* getMenuInCatHandler(resp: HttpResponse, callbackParams: { action: CallMenuInCatAction }) {
  const { onFailureCallback, onSuccessCallback, search } = callbackParams.action.payload;
  if (resp.success) {
    yield put(catCreators.setCatState(CAT_STATE_KEY.DETAIL, resp.data));
    if (!search) {
      yield put(catCreators.setCatState(CAT_STATE_KEY.ORIGINAL_MENU_IN_CAT, resp.data));
    }
    if (onSuccessCallback) {
      yield call(onSuccessCallback, resp.data);
    }
  } else {
    yield put(catCreators.setCatState(CAT_STATE_KEY.DETAIL, undefined));
    if (onFailureCallback) {
      yield call(onFailureCallback);
    }
  }
}

function* sortMenuSequence(action: SortMenuSequenceAction) {
  yield put(httpCreators.request({
    id: CAT_REQUEST_ID_LIST.SORT_MENU_SEQUENCE,
    sagaHandler: sortMenuSequenceHandler,
    service: CatService.sortMenuSequenceInCat,
    serviceParams: {
      menuCategoryId: action.payload.menuCategoryId,
      menuIds: action.payload.menuIds,
    },
    callbackParams: { action },
  }));
}

function* sortMenuSequenceHandler(resp: HttpResponse, callbackParams: { action: SortMenuSequenceAction }) {
  const { onSuccessCallback, onFailureCallback } = callbackParams.action.payload;
  if (resp.success) {
    if (onSuccessCallback) {
      yield call(onSuccessCallback);
    }
  } else {
    if (onFailureCallback) {
      yield call(onFailureCallback);
    } else {
      yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
        visible: true,
        onOk: noop,
        type: MODAL_TYPE.ERROR,
      }));
    }
  }
}

export const catSagas = {
  callFoodCategory,
  callMenuInCat,
  getFoodCategoryHandler,
  postCatHandler,
  patchCatHandler,
  deleteCatHandler,
  updateCategorySequenceHandler,    
  getMenuInCatHandler,
  sortMenuSequence,
  sortMenuSequenceHandler,
  watchers: [
    takeLatest(CAT_ACTION_TYPE.CALL_FOOD_CATEGORY, callFoodCategory),
    takeLatest(CAT_ACTION_TYPE.CALL_FULL_FOOD_CATEGORY, callFullFoodCategory),
    takeLatest(CAT_ACTION_TYPE.CALL_MENU_IN_CAT, callMenuInCat),
    takeLatest(CAT_ACTION_TYPE.SORT_MENU_SEQUENCE, sortMenuSequence),
  ]
};

